import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";

import Layout from "./layout/Layout";

import Home from "./component/Home/Home";
import About from "./component/Home/About";
import Contact from "./component/Home/Contact";
import Cart from "./component/Home/Cart";
import Ourshop from "./component/Home/Ourshop";
import ProductDetails from "./component/Home/ProductDetails";
import Login from "./component/Home/Login";
import CategoryDetails from "./component/Home/CategoryDetails";

// 🟢 NEW PAGES
import SearchResults from "./component/Home/SearchResults";
import Wishlist from "./component/Home/Wishlist";
import UserMessages from "./component/Home/UserMessages"; // <--- IMPORT ADDED

// 🟢 Toastify
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// 🟢 Legal pages
import PrivacyPolicy from "./component/Home/PrivacyPolicy";
import TermsConditions from "./component/Home/TermsConditions";

// 🟢 User pages
import UserProfile from "./component/Home/UserProfile";
import OrderHistory from "./component/Home/OrderHistory";

function App() {
  return (
    <Router>
      <Layout>
        <Switch>
          {/* Static pages */}
          <Route exact path="/about" component={About} />
          <Route exact path="/contact-us" component={Contact} />
          <Route exact path="/our-shop" component={Ourshop} />
          <Route exact path="/cart" component={Cart} />
          <Route exact path="/login" component={Login} />

          {/* 🟢 NEW ROUTES */}
          <Route exact path="/search" component={SearchResults} />
          <Route exact path="/wishlist" component={Wishlist} />
          <Route exact path="/messages" component={UserMessages} /> {/* <--- ROUTE ADDED */}

          {/* 🟢 User pages */}
          <Route exact path="/profile" component={UserProfile} />
          <Route exact path="/orders" component={OrderHistory} />

          {/* 🟢 Legal pages */}
          <Route exact path="/privacy" component={PrivacyPolicy} />
          <Route exact path="/terms" component={TermsConditions} />

          {/* Category-wise products */}
          <Route
            exact
            path="/category/:categoryName"
            component={CategoryDetails}
          />

          {/* Product details */}
          <Route exact path="/product/:id" component={ProductDetails} />

          {/* Home — ALWAYS LAST */}
          <Route exact path="/" component={Home} />
        </Switch>
      </Layout>

      {/* 🟢 Toast Container (GLOBAL) */}
      <ToastContainer
        position="top-center"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </Router>
  );
}

export default App;